import { render } from "./Shiirelist.vue?vue&type=template&id=2c2b5f4c&scoped=true&ts=true"
import script from "./Shiirelist.vue?vue&type=script&lang=ts"
export * from "./Shiirelist.vue?vue&type=script&lang=ts"

import "./Shiirelist.vue?vue&type=style&index=0&id=2c2b5f4c&scoped=true&lang=css"
import "./Shiirelist.vue?vue&type=style&index=1&id=2c2b5f4c&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2b5f4c"]])

export default __exports__